<template>
  <div>
    <b-modal ref="mdlImpegnativa" :title="'Impegnativa'" @shown="onShown" size="xl"
      style="height: 100%; max-height: 100%; width: 80%; max-width: 80%" centered scrollable footer-tag="footer"
      no-close-on-backdrop :no-close-on-esc="noCloseOnEsc" @hide="onHide" :hide-header-close="hideHeaderClose">
      <b-row class="sa-padding-left text-left" style="margin-left: 0.5rem; margin-right: 0.5rem; margin-bottom: 2rem">

        <b-col cols="12" class="my-3 px-2">
          <div class="d-flex align-items-center p-2 rounded"
            style="background: linear-gradient(90deg, #eef8ff 0%, #ffffff 100%); border-left: 4px solid #00a3ff;">
            <span class="badge rounded-circle d-flex align-items-center justify-content-center mr-3 shadow-sm"
              style="width: 34px; height: 34px; background: linear-gradient(135deg, #00a3ff 0%, #0077cc 100%); color: white; font-size: 15px; font-weight: bold;">
              <i class="bi bi-info-circle-fill"></i> </span>
            <h5 class="mb-0 font-weight-bold" style="color: #005691; letter-spacing: 0.5px">Informazioni Ricetta</h5>
          </div>
        </b-col>
        <b-col cols="4" xs="12" sm="12" md="12" :lg="completeAccettazioneSsn ? 4 : 6"
          :xl="completeAccettazioneSsn ? 4 : 6">
          <label class="sa-data-label">Nre</label>
          <b-form-input :disabled="isModificaDisattivato() || disabledPri" v-model="localData.codiceBar1"
            class="text-upper" placeholder="Primi 5 Caratteri" maxlength="5"></b-form-input>
        </b-col>
        <b-col cols="6" xs="12" sm="12" md="12" :lg="completeAccettazioneSsn ? 4 : 6"
          :xl="completeAccettazioneSsn ? 4 : 6">
          <b-form-input :disabled="isModificaDisattivato() || disabledPri" v-model="localData.codiceBar2"
            class="text-upper" placeholder="Successivi 10 Caratteri" style="margin-top: 21px;"></b-form-input></b-col>
        <b-col v-if="completeAccettazioneSsn" cols="2" xs="12" sm="12" md="12" lg="2" xl="2">
          <button :disabled="isModificaDisattivato() || disabledPri" type="button" style="margin-top: 21px;"
            @click="onRicercaAssistito" class="sa-ft-action-btn primary">
            <span>Ricerca</span>
            <small>🔍</small>
          </button>
        </b-col>


        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
          <label class="sa-label-data">Tipologia Ricetta</label>
          <b-form-select v-model="localData.tipologiaRicetta" :options="tipologiaRicettaOptions" value-field="value"
            text-field="text" :disabled="isModificaDisattivato() || disablitaSceltaTipoRicetta"
            @change="onChangeTipologia">
            <template #first>
              <b-form-select-option disabled :value="null">Seleziona</b-form-select-option>
            </template>
          </b-form-select>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
          <label class="sa-label-data">Priorità</label>
          <b-form-select id="inline-form-custom-select-pref" v-model="localData.classePriorita"
            class="mb-2 mr-sm-2 mb-sm-0" :disabled="isModificaDisattivato()" :options="prioritaOptions" :value="null">
            <template #first>
              <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
            </template>
          </b-form-select>
        </b-col>

        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
          <label class="sa-label-data">Codice Fiscale Assisito</label>
          <b-form-input :disabled="isModificaDisattivato()" class="text-upper"
            v-model="localData.codiceFiscaleAssistito"></b-form-input>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
          <label class="sa-label-data">Data Prescrizione</label>
          <date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="localData.dataPrescrizione"
            :disabled="isModificaDisattivato()" type="date"></date-picker>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2" v-if="!completeAccettazioneSsn">
          <label class="sa-label-data">Ciclo Ricetta</label>
          <b-form-input type="number" :disabled="isModificaDisattivato()"
            v-model="localData.quantitaErogabile"></b-form-input>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
          <label class="sa-label-data">Diagnosi codificata</label>
          <b-input-group class="mt-3">
            <b-form-input v-model="localData.descrizioneDiagnosi" value="descrizioneDiagnosi"
              :disabled="true"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="isModificaDisattivato()" @click="onClickBtnRicercaIcdIx(1)"
                variant="outline-info"><font-awesome-icon icon="search" /></b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2">
          <label class="sa-label-data">Codice Esenzione</label>
          <b-input-group class="mt-3">
            <b-form-input v-model="localData.codiceEsenzione" :disabled="true"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="isModificaDisattivato()" @click="onClickBtnRicercaCodiciEsenzione()"
                variant="outline-info"><font-awesome-icon icon="search" /></b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="1" xl="1">
          <label class="sa-label-data">Non Esente</label>
          <b-form-checkbox switch v-model="localData.nonEsente" :disabled="isModificaDisattivato()"></b-form-checkbox>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="1" xl="1">
          <label class="sa-label-data">Reddito</label>
          <b-form-checkbox switch v-model="localData.esenteReddito"
            :disabled="isModificaDisattivato()"></b-form-checkbox>
        </b-col>
        <template v-if="!completeAccettazioneSsn">
          <b-col cols="1">
            <div class="text-center">
              <label class="sa-label-data">Erogabile</label>
              <div style=" display: block ruby;">
                <div :style="{
                  minWidth: '22px',
                  height: '22px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: '25px',
                  background: '#00a3ff',
                  color: 'white',
                  fontWeight: '600',
                  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                }">{{ localData.quantitaErogabile }}
                </div>
              </div>

            </div>

          </b-col>
          <b-col cols="1">
            <div class="text-center">
              <label class="sa-label-data">Eseguito</label>
              <div style=" display: block ruby;">
                <div :style="{
                  minWidth: '22px',
                  height: '22px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: '25px',
                  background: '#218838',
                  color: 'white',
                  fontWeight: '600',
                  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                }">{{ getEseguiti() }}
                </div>
              </div>

            </div>

          </b-col>
          <b-col cols="1">
            <div class="text-center">
              <label class="sa-label-data">Residio</label>
              <div style=" display: block ruby;">
                <div :style="{
                  minWidth: '22px',
                  height: '22px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: '25px',
                  background: '#ffc107',
                  color: 'white',
                  fontWeight: '600',
                  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                }">{{ getResidio() }}
                </div>
              </div>

            </div>

          </b-col>
        </template>

        <b-col cols="12" class="my-3 px-2">
          <div class="d-flex align-items-center p-2 rounded"
            style="background: linear-gradient(90deg, #eef8ff 0%, #ffffff 100%); border-left: 4px solid #00a3ff;">
            <span class="badge rounded-circle d-flex align-items-center justify-content-center mr-3 shadow-sm"
              style="width: 34px; height: 34px; background: linear-gradient(135deg, #00a3ff 0%, #0077cc 100%); color: white; font-size: 15px; font-weight: bold;">
              <i class="bi bi-file-earmark-person"></i> </span>
            <h5 class="mb-0 font-weight-bold" style="color: #005691; letter-spacing: 0.5px">Informazioni Medico
              Prescrittore
            </h5>
          </div>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2">
          <label class="sa-label-data">Regione</label>
          <b-form-select id="inline-form-custom-select-pref" class="mb-2 mr-sm-2 mb-sm-0" :value="null"
            :disabled="isModificaDisattivato()" v-model="localData.presRegione" value-field="codiceIstat"
            :state="getStateValidationField('presRegione')" text-field="regione" :options="regioniOptions" required>
            <template #first>
              <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
            </template>
          </b-form-select>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
          <label class="sa-label-data">Matricola</label>
          <b-input-group class="mt-3">
            <b-form-input :disabled="isModificaDisattivato()" class="text-upper"
              v-model="localData.matricola"></b-form-input>
            <b-input-group-append>
              <b-button variant="outline-info" @click="onClickSelezionaMedico()"
                :disabled="isModificaDisattivato()"><font-awesome-icon icon="search" /></b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2">
          <label class="sa-label-data">Pres. Cognome</label>
          <b-form-input :disabled="isModificaDisattivato()" class="text-upper"
            v-model="localData.presCognome"></b-form-input>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2">
          <label class="sa-label-data">Pres. Nome</label>
          <b-form-input :disabled="isModificaDisattivato()" class="text-upper"
            v-model="localData.presNome"></b-form-input>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2">
          <label class="sa-label-data">Pres. Codice Fiscale</label>
          <b-form-input :disabled="isModificaDisattivato()" class="text-upper"
            v-model="localData.presCodiceFiscale"></b-form-input>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="1" xl="1">
          <label class="sa-label-data">Pres. Tipo. </label>
          <b-form-select id="inline-form-custom-select-pref" v-model="localData.codiceSpecializzazioneMedico"
            class="mb-2 mr-sm-2 mb-sm-0" :disabled="isModificaDisattivato()" :options="presTipologiaOptions"
            :value="null">
            <template #first>
              <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
            </template>
          </b-form-select>
        </b-col>
        <b-col cols="12" class="my-3 px-2">
          <div class="d-flex align-items-center p-2 rounded"
            style="background: linear-gradient(90deg, #eef8ff 0%, #ffffff 100%); border-left: 4px solid #00a3ff;">
            <span class="badge rounded-circle d-flex align-items-center justify-content-center mr-3 shadow-sm"
              style="width: 34px; height: 34px; background: linear-gradient(135deg, #00a3ff 0%, #0077cc 100%); color: white; font-size: 15px; font-weight: bold;">
              <i class="bi bi-flag-fill"></i></span>
            <h5 class="mb-0 font-weight-bold" style="color: #005691; letter-spacing: 0.5px">Prestazioni</h5>
          </div>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <AccettazioneSsnPrestazioniComponent :isViewer="isViewer" :prestazioniRicetta="localData.prestazioni"
            :tipologiaRicetta="localData.tipologiaRicetta" @onAggiungiPrestazione="onAggiungiPrestazione"
            @updatePrestazioni="onUpdatePrestazioni" ref="cmpAccettazioneSsnPrestazioniComponent" />
        </b-col>
      </b-row>
      <template #modal-footer>
        <div class="d-flex justify-content-end w-100">
          <b-button size="sm" variant="danger" class="ml-2" v-if="btnAnnullaShow" @click="onAnnulla"> Annulla
          </b-button>
          <b-button v-if="!isModifica && !internalSave && !isViewer" size="sm" variant="success" class="ml-2"
            @click="onAggiungiImpegnativa" :disabled="isDisabledAggiungiImpegnativa()"> Aggiungi Impegnativa </b-button>
          <b-button v-else-if="!isModifica && internalSave && !isViewer" size="sm" variant="success" class="ml-2"
            @click="onCreaImpegnativaInternal" :disabled="isDisabledAggiungiImpegnativa()"> Crea Impegnativa </b-button>
          <b-button v-if="isModifica && !isViewer" size="sm" variant="success" class="ml-2"
            @click="onModificaImpegnativa()" :disabled="isTastoModificaAttivo()"> Modifica Impegnativa </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal ref="mdlMedici" size="xl" title="Seleziona un Medico" @ok="confermaSelezioneMedico" ok-title="Conferma"
      cancel-title="Annulla">
      <b-form @submit.prevent="onRicercaMediciPrescrittori">
        <b-row>
          <b-col cols="4" class="my-1">
            <label for="input-1" class="sa-form-label">Nome Medico</label>
            <b-form-input id="input-1" v-model="filtroMediciPrescrittori.pres_nome" type="text"
              placeholder="Nome Medico Prescrittore"></b-form-input>
          </b-col>
          <b-col cols="4" class="my-1">
            <label for="input-2" class="sa-form-label">Cognome Medico</label>
            <b-form-input id="input-2" v-model="filtroMediciPrescrittori.pres_cognome" type="text"
              placeholder="Cognome Medico Prescrittore"></b-form-input>
          </b-col>
          <b-col cols="4" class="my-1">
            <label for="input-2" class="sa-form-label">Matricola</label>
            <b-form-input id="input-2" v-model="filtroMediciPrescrittori.matricola" type="text"
              placeholder="Matricola Medico Prescrittore"></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="sa-padding-right text-right">
            <b-button type="submit" variant="primary">Cerca</b-button>
          </b-col>
        </b-row>
      </b-form>
      <b-table selectable select-mode="single" :items="medici" :fields="fieldsMedici" responsive striped hover
        @ok="confermaSelezioneMedico" @row-selected="onRowSelected">
        <template #cell(nome)="row">
          <span>{{ row.item.nome }} {{ row.item.cognome }}</span>
        </template>
      </b-table>
    </b-modal>
    <b-modal ref="mdlCodiciIcdIx" id="mdlCodiciIcdIx" title="CODICI ICD-IX" size="xl" @ok="onOkMdlCodiciIcdIx">
      <b-form @submit.prevent="onRicercaCodiceIcdx">
        <b-row>
          <b-col cols="6" class="my-1">
            <label for="input-1" class="sa-form-label">Codice IcdIX</label>
            <b-form-input id="input-1" v-model="filtroIcdix.codice" type="text"
              placeholder="Codice IcdIX"></b-form-input>
          </b-col>
          <b-col cols="6" class="my-1">
            <label for="input-2" class="sa-form-label">Descrizione Codice IcdIX</label>
            <b-form-input id="input-2" v-model="filtroIcdix.descrizione" type="text"
              placeholder="Descrizione Codice IcdIX"></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="sa-padding-right text-right">
            <b-button type="submit" variant="primary">Cerca</b-button>
          </b-col>
        </b-row>
      </b-form>
      <div style="max-height: 200px; overflow-y: scroll">
        <b-table ref="table" sticky-header responsive stacked="lg" striped hover selectable select-mode="single"
          :items="itemsIcdix" :fields="fieldsiCDX" :current-page="1" :per-page="1000" @ok="onOkMdlCodiciIcdIx"
          @row-selected="setRowSelected" sort-icon-left head-variant="light" class="sa-b-table">
        </b-table>
      </div>
    </b-modal>
    <b-modal ref="mdlCodiciEsenzione" id="mdlCodiciEsenzione" title="CODICI ESENZIONE" size="xl"
      @ok="onOkMdlCodiciEsenzione">
      <b-form @submit.prevent="onRicercaCodiciEsenzioni">
        <b-row>
          <b-col cols="6" class="my-1">
            <label for="input-1" class="sa-form-label">Codice</label>
            <b-form-input id="input-1" v-model="filtroCodiciEsenzione.codice" type="text"
              placeholder="Codice"></b-form-input>
          </b-col>
          <b-col cols="6" class="my-1">
            <label for="input-2" class="sa-form-label">Descrizione</label>
            <b-form-input id="input-2" v-model="filtroCodiciEsenzione.descrizione" type="text"
              placeholder="Descrizione"></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="sa-padding-right text-right">
            <b-button type="submit" variant="primary">Cerca</b-button>
          </b-col>
        </b-row>
      </b-form>
      <div style="max-height: 200px; overflow-y: scroll">
        <b-table ref="table" sticky-header responsive stacked="lg" striped hover selectable select-mode="single"
          :items="itemsCodiceEsenzione" :fields="fieldsCodice" :current-page="1" :per-page="1000"
          @ok="onOkMdlCodiciIcdIx" @row-selected="setCodiceEsenzioneSelected" sort-icon-left head-variant="light"
          class="sa-b-table">
        </b-table>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import DatePicker from "vue2-datepicker";
import AccettazioneSsnPrestazioniComponent from "./AccettazioneSsnPrestazioniComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin.js";
import toast from "../../../../template/layout/utility/sa-toast.js";
export default {
  mixins: [UtilityMixin],
  components: { AccettazioneSsnPrestazioniComponent, DatePicker },
  inject: ["openShowModalLoading", "closeShowModalLoading"],
  props: {
    isEdit: {
      type: Boolean,
      require: false,
      default: () => {
        return false;
      },
    },
    hideHeaderClose: {
      type: Boolean,
      require: false,
      default: () => {
        return false;
      },
    },
    internalSave: {
      type: Boolean,
      require: false,
      default: () => {
        return false;
      },
    },
    codiceFiscalePaziente: {
      type: String,
      require: false,
      default: () => {
        return null;
      },
    },
    noCloseOnEsc: {
      type: Boolean,
      require: false,
      default: () => {
        return true;
      },
    },
    btnAnnullaShow: {
      type: Boolean,
      require: false,
      default: () => {
        return false;
      },
    },
  },

  data() {
    return {
      id: null,
      accettazioneJson: {},
      isDematerializzata: false,
      completeBookingSsn: this.appConfig.completeBookingSSN,
      rowSelected: null,
      pathResourceICDIX: "/serviziicdix",
      pathResourceCodiceEsenzione: "/codiceesenzione",
      isModifica: false,
      isNuovoRecord: false,
      pathResource: "/accettazionericette",
      filtroMediciPrescrittori: {},
      form: "",
      isViewer: false,
      medici: [],
      filtroCodiciEsenzione: {
        codice: null,
        descrizione: null,
      },
      fieldsCodice: [
        {
          label: "Codice Esenzione",
          key: "codice",
          thStyle: "width: 15rem text-center",
          tdStyle: "text-center",
          sortable: true,
        },
        {
          label: "Descrizione",
          key: "descrizione",
          thStyle: "width: 15rem text-center",
          tdStyle: "text-center",
          sortable: true,
        },
      ],
      fieldsiCDX: [
        {
          label: "Codice IcDx",
          key: "codiceIcdix",
          thStyle: "width: 15rem text-center",
          tdStyle: "text-center",
          sortable: true,
        },
        {
          label: "Descrizione IcDx",
          key: "descrizioneIcdix",
          thStyle: "width: 15rem text-center",
          tdStyle: "text-center",
          sortable: true,
        },
      ],
      fieldsMedici: [
        {
          field: "matricola",
          label: "Matricola",
          type: "string",
          sortable: true,
          filterable: true,
        },
        {
          field: "nome",
          label: "Nome",
          type: "string",
          sortable: true,
          filterable: true,
        },
        {
          field: "codiceFiscale",
          label: "Codice Fiscale",
          type: "string",
          sortable: false,
          filterable: true,
        },
        {
          field: "tipologia",
          label: "Tipologia",
          type: "string",
          sortable: true,
          filterable: true,
        },
        {
          field: "regione",
          label: "Regione",
          type: "string",
          sortable: true,
          filterable: true,
        },
      ],
      rigaSelezionataDiagnosiIndex: null,
      regioniOptions: [],
      rules: {
        presRegione: {
          msg: "Regione Prescrittore non valido",
          rule: (val) => val != null,
        },
      },
      itemsIcdix: [],

      filtroIcdix: {
        codiceIcdix: null,
        descrizioneIcdix: null,
      },
      blockEsenzione: false,
      presidio: { codiceStruttura: null },
      localData: {
        tipologiaRicetta: null,
        codiceFiscaleAssistito: null,
        dataPrescrizione: new Date().getTime(),
        dataInizioErogazione: new Date().getTime(),
        dataFineErogazione: new Date().getTime(),
        presRegione: null,
        matricola: null,

        presCognome: null,
        presNome: null,
        codiceBar1: null,
        statoAttuale: "PRESA IN CARICO",
        codiceBar2: null,
        presCodiceFiscale: null,
        codiceSpecializzazioneMedico: null,
        quantitaErogabile: 0,
        descrizioneDiagnosi: null,
        nonEsente: true,
        esenteReddito: false,
        codiceEsenzione: null,
        classePriorita: null,
        cfMedico: null,
        prestazioni: [],
        _showDetails: false,
      },
      codicePresidio: null,
      jsonDataIntegrazione: null,
      itemsCodiceEsenzione: [],
      indexRowSelected: null,
      rigaSelezionataDiagnosi: [],
      rigaSelezionataCodice: [],
      indexSelezionato: 1,
      presRegioniOptions: [],
      disabledPri: false,
      tipologiaRicettaOptions: [
        { text: "CONV", value: "CONV" },
        { text: "SSN", value: "SSN" },
        { text: "ROSSA", value: "ROSSA" },
        { text: "PRIVATA", value: "PRIVATA" },
        { text: "DEMATERIALIZZATA", value: "DEMATERIALIZZATA" },
      ],
      presTipologiaOptions: ["SPEC(SUMAI)", "DIP.ASL", "MMG", "GM", "OSP", "PEDIATRA", "GMTURISTICA", "MOSP-UNIV", "ALTRO"],
      prioritaOptions: ["U", "B", "D", "P"],
      tipologiaAccettazioneConfig: this.appConfig.tipologieRicettaAccettazioneSSN,
      completeAccettazioneSsn: this.appConfig.completeAccettazioneSSN,
      disablitaSceltaTipoRicetta: false,
    };
  },
  mounted() {
    let me = this;
    me.loadRegioni();
    me.setComponentChild();
    this.id = this.$route.params.id;


    me.localData.codiceFiscaleAssistito = me.codiceFiscalePaziente;
    let tmpPresidio = window.localStorage.getItem("presidio");
    if (tmpPresidio) {
      let presidio = JSON.parse(tmpPresidio);
      this.presidio = presidio;
      this.codicePresidio = presidio.codicePresidio;
    }
  },
  computed: {

  },
  methods: {
    isDisabledAggiungiImpegnativa() {
      let me = this;

      ///GESTIONE DA FARE PER ANMINS
      if (me.localData.tipologiaRicetta == null) {
        return true;
      }
      if (me.localData.tipologiaRicetta === "PRIVATA") {
        return false;
      }
      if (me.localData.codiceBar1 == null || me.localData.codiceBar1 === "") {
        return true;
      }
      if (me.localData.codiceBar2 == null || me.localData.codiceBar2 === "") {
        return true;
      }
      return false;
    },
    setRicetta(ricetta, jsonData) {
      this.localData = ricetta;
      this.accettazioneJson = jsonData;
      this.show();
    },
    getResidio() {
      return this.localData.quantitaErogabile - this.localData.prestazioni.reduce((acc, p) => acc + (p.appuntamenti ? p.appuntamenti.length : 0), 0);
    },
    getEseguiti() {
      return this.localData.prestazioni.reduce((acc, p) => acc + (p.appuntamenti ? p.appuntamenti.length : 0), 0);
    },
    init(jsonData) {
      let me = this;
      this.accettazioneJson = jsonData;
      me.localData = {
        tipologiaRicetta: null,
        dataPrescrizione: new Date().getTime(),
        dataInizioErogazione: new Date().getTime(),
        dataFineErogazione: new Date().getTime(),
        presRegione: null,
        matricola: null,
        presCognome: null,
        codiceBar1: null,
        codiceBar2: null,
        statoAttuale: "NON_PROGRAMMATO",
        presNome: null,
        quantitaErogabile: 0,
        presCodiceFiscale: null,
        codiceSpecializzazioneMedico: null,
        descrizioneDiagnosi: null,
        nonEsente: false,
        esenteReddito: false,
        codiceEsenzione: null,
        classePriorita: null,
        codiceFiscaleAssistito: jsonData.accettazioneAnagrafica.identificativo,
        prestazioni: [],
      };

      this.isNuovoRecord = true;
      this.show();
    },
    creaImpegnativaTramitePri(jsonData, pri) {
      let me = this;
      this.accettazioneJson = jsonData;
      me.localData = {
        tipologiaRicetta: "PRIVATA",
        dataPrescrizione: new Date().getTime(),
        dataInizioErogazione: new Date().getTime(),
        dataFineErogazione: new Date().getTime(),
        presRegione: null,
        matricola: null,
        presCognome: null,
        codiceBar1: "P.R.I",
        codiceBar2: pri.idPri,
        idAccettazione: jsonData.id,
        statoAttuale: "NON_PROGRAMMATO",
        presNome: null,
        quantitaErogabile: 0,
        presCodiceFiscale: null,
        codiceSpecializzazioneMedico: null,
        descrizioneDiagnosi: null,
        nonEsente: false,
        esenteReddito: false,
        codiceEsenzione: null,
        classePriorita: null,
        codiceFiscaleAssistito: jsonData.accettazioneAnagrafica.identificativo,
        prestazioni: [],
      };


      this.disabledPri = true;
      this.isNuovoRecord = true;
      this.show();
    },
    onShown() {

      if (this.$refs.cmpAccettazioneSsnPrestazioniComponent) {
        this.$refs.cmpAccettazioneSsnPrestazioniComponent.init(this.localData, this.accettazioneJson);
      }
      if (!this.completeAccettazioneSsn) {
        if (!this.localData.tipologiaRicetta) {
          this.localData.tipologiaRicetta = "PRIVATA";
        }
        if (!this.localData.codiceBar1) {
          this.localData.codiceBar1 = "PVT"
        }
        if (!this.localData.quantitaErogabile) {
          this.localData.quantitaErogabile = 0;
        }



      }
      this.disablitaSceltaTipoRicetta = false

    },
    onHide() {
      this.isModifica = false;
      this.disabledPri = false;
      this.isNuovoRecord = false;
      this.isViewer = false;
    },
    show() {
      this.$refs.mdlImpegnativa.show();
    },
    showDematerializzata(accettazione) {
      this.isDematerializzata = true;
      this.init(accettazione.accettazione);
    },
    hide() {
      this.$refs.mdlImpegnativa.hide();
    },
    onRicercaAssistito() {
      if (this.localData.codiceBar1 == null || this.localData.codiceBar1.trim() == "") {
        if (this.localData.codiceBar2 == null || this.localData.codiceBar2.trim() == "") {
          toast.error("Inserire NRE valido !")
          this.closeShowModalLoading();
          return;
        }
        toast.error("Inserire NRE valido !")
        this.closeShowModalLoading();
        return
      }
      this.openShowModalLoading();
      let filter = {
        nre: this.localData.codiceBar1 + this.localData.codiceBar2
      }
      let link = process.env.VUE_APP_PATH_API + "/saccsarrlazio/integrazionenre/" + this.presidio.codiceStruttura + "/" + this.codicePresidio;
      axios.get(link, { params: filter }).then((response) => {
        this.jsonDataIntegrazione = response.data.data;
        this.localData = response.data.data.ricette[0];
        this.$refs.cmpAccettazioneSsnPrestazioniComponent.init(this.localData, this.jsonDataIntegrazione);
        toast.success("Recupero dati effettuato con successo")
        this.closeShowModalLoading();
      }).catch((err) => {
        toast.error(err.response.data.messaggio)
        this.closeShowModalLoading();
      });
    },


    onUpdatePrestazioni(prestazioni) {
      this.localData.prestazioni = prestazioni;
      this.$refs.cmpAccettazioneSsnPrestazioniComponent.init(this.localData, this.accettazioneJson);
    },
    onAggiungiPrestazione(row) {
      delete row.item.new;
      this.localData.prestazioni.push(JSON.parse(JSON.stringify(row.item)));
      this.$refs.cmpAccettazioneSsnPrestazioniComponent.init(this.localData, this.accettazioneJson);
    },
    onRicercaCodiciEsenzioni() {
      let me = this;
      me.loadCodiciEsenzione();
    },

    loadCodiciEsenzione() {
      let me = this;
      me.showModalLoading = true;
      let link = process.env.VUE_APP_PATH_API + me.pathResourceCodiceEsenzione + "?forPage=" + 1000 + "&page=" + 1;
      axios
        .get(link, { params: this.filtroCodiciEsenzione })
        .then((response) => {
          me.itemsCodiceEsenzione = [];
          me.itemsCodiceEsenzione = response.data.data.list;
          me.showModalLoading = false;
        })
        .catch(() => {
          me.showModalLoading = false;
        });
    },
    loadCodiciIcdix() {
      let me = this;
      me.showModalLoading = true;
      let link = process.env.VUE_APP_PATH_API + me.pathResourceICDIX + "?forPage=" + 1000 + "&page=" + 1;
      axios
        .get(link, { params: this.filtroIcdix })
        .then((response) => {
          me.itemsIcdix = [];
          me.itemsIcdix = response.data.data.list;
          me.showModalLoading = false;
        })
        .catch(() => {
          me.showModalLoading = false;
        });
    },
    loadMediciPrescrittori() {
      let me = this;
      me.showModalLoading = true;
      let link = process.env.VUE_APP_PATH_API + "/accettazionericette/mediciprescrittori";
      axios
        .get(link, { params: this.filtroMediciPrescrittori })
        .then((response) => {
          me.medici = [];
          me.medici = response.data.data;
          me.showModalLoading = false;
        })
        .catch(() => {
          me.showModalLoading = false;
        });
    },
    setRicettaModificare(json, jsonDataAccettazione) {
      let me = this;
      me.indexRowSelected = json.index;
      me.localData = JSON.parse(JSON.stringify(json.item));
      this.accettazioneJson = jsonDataAccettazione.accettazione;
      me.loadCodiciIcdix();
      me.loadCodiciEsenzione();
      me.isModifica = true;

    },
    setRicettaVisualizzazione(json, jsonDataAccettazione) {
      let me = this;
      me.indexRowSelected = json.index;
      me.localData = JSON.parse(JSON.stringify(json.item));
      this.accettazioneJson = jsonDataAccettazione.accettazione;
      this.isViewer = true;

    },
    setRowSelected(row) {
      let me = this;
      me.rigaSelezionataDiagnosi = row;
    },
    setCodiceEsenzioneSelected(row) {
      let me = this;
      me.rigaSelezionataCodice = row;
    },

    onRicercaMediciPrescrittori() {
      let me = this;
      me.loadMediciPrescrittori();
    },
    onModificaImpegnativa() {
      let me = this;
      if (this.localData.id && this.localData.id != '-1') {

        let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + this.localData.id;
        axios.put(link, this.localData)
          .then(() => {
            this.hide();
            toast.success("Modifica avvenuta con successo !");
            this.$emit("reload");
          })
          .catch((e) => {
            console.log(e);
          });


      } else {
        this.$emit("onModificaImpegnativa", me.localData, me.indexRowSelected);
      }
    },

    onRicercaCodiceIcdx() {
      let me = this;
      me.loadCodiciIcdix();
    },
    onOkMdlCodiciEsenzione() {
      let me = this;
      me.localData.codiceEsenzione = me.rigaSelezionataCodice[0].codice;
      me.localData.nonEsente = false;
      me.blockEsenzione = true;
    },
    onOkMdlCodiciIcdIx() {
      let me = this;
      switch (me.indexSelezionato) {
        case 1:
          me.localData.codiceDiagnosi = me.rigaSelezionataDiagnosi[0].codiceIcdix;
          me.localData.descrizioneDiagnosi = me.rigaSelezionataDiagnosi[0].descrizioneIcdix;
          break;
      }
    },
    isModificaDisattivato() {

      if (this.isViewer) {
        return true;
      }

      let tipologiaRicetta = this.localData.tipologiaRicetta;
      if (tipologiaRicetta == "SSN" || tipologiaRicetta == "DEMATERIALIZZATA") {
        return true;
      }
      return !this.isEdit;
    },
    isTastoModificaAttivo() {
      let me = this;
      return !me.isEdit;
    },



    onClickBtnRicercaIcdIx(index) {
      let me = this;
      me.rigaSelezionataDiagnosi = index;
      this.$refs.mdlCodiciIcdIx.show();
    },
    onClickBtnRicercaCodiciEsenzione(index) {
      let me = this;
      me.rigaSelezionataDiagnosiIndex = index;
      this.$refs.mdlCodiciEsenzione.show();
    },
    onClickSelezionaMedico() {
      this.$refs.mdlMedici.show();
    },
    setComponentChild() {
      let me = this;
      me.edit(me.jsonData);
    },
    edit(jsonData) {
      let me = this;
      me.localData = { ...me.localData, ...jsonData };
    },
    getStateValidationField(fieldName) {
      let me = this;
      const field = me.localData[fieldName];
      if (field === null) {
        return null;
      }
      const rules = me.rules[fieldName];
      if (!rules) {
        return true;
      }
      return rules.rule(field);
    },

    getMsg(fieldName) {
      let me = this;
      const fieldValue = me.localData[fieldName];
      const valid = me.getStateValidationField(fieldName);
      const rules = me.rules[fieldName];
      if ((fieldValue && !valid) || fieldValue == null) {
        if (rules) return rules.msg;
      }
      return null;
    },

    onRowSelected(row) {
      let me = this;
      me.rowSelected = row;
    },
    onChangeTipologia(tipo) {
      let me = this;
      if ((!this.localData.id || this.localData.id == "-1") && (this.localData.tipologiaRicetta === "SSN" || this.localData.tipologiaRicetta === "DEMATERIALIZZATA")) {
        this.localData.tipologiaRicetta = null;
        toast.warning("Per le impegnative SSN o Dematerilizzate , usare il flusso di recupero , automaticamente verrà popolata questa interfaccia")
        return;
      }
      if (!this.localData.id || this.localData.id == "-1") {
        if (tipo === "PRIVATA") {
          me.localData.codiceBar1 = "PVT";
          me.localData.codiceBar2 = crypto.randomUUID().substring(0, 5);


        } else {
          me.localData.codiceBar1 = "";
          me.localData.codiceBar2 = "";
        }
        if (this.localData.tipologiaRicetta === "DEMATERIALIZZATA" || this.localData.tipologiaRicetta === "SSN") {
          me.localData = {
            tipologiaRicetta: me.localData.tipologiaRicetta,
            dataPrescrizione: new Date().getTime(),
            dataInizioErogazione: new Date().getTime(),
            dataFineErogazione: new Date().getTime(),
            presRegione: null,
            matricola: null,
            presCognome: null,
            statoAttuale: me.localData.statoAttuale,
            presNome: null,
            presCodiceFiscale: null,
            codiceSpecializzazioneMedico: null,
            descrizioneDiagnosi: null,
            nonEsente: false,
            esenteReddito: false,
            codiceEsenzione: null,
            classePriorita: null,

            codiceFiscaleAssistito: me.localData.codiceFiscaleAssistito,
            prestazioni: [],
          };
        }
      }
    },
    confermaSelezioneMedico() {
      let me = this;
      let json = me.rowSelected[0];
      me.localData.matricola = json.matricola;
      me.localData.presNome = json.nome;
      me.localData.presCognome = json.cognome;
      me.localData.presCodiceFiscale = json.codiceFiscale;
      me.localData.codiceSpecializzazioneMedico = json.tipologia;
      me.localData.presRegione = json.regione;
      me.localData.cfMedico = json.codiceFiscale;
    },

    onAnnulla() {
      let me = this;
      me.$emit("onAnnulla", {
        tipologiaRicetta: null,
        dataPrescrizione: new Date().getTime(),
        dataInizioErogazione: new Date().getTime(),
        dataFineErogazione: new Date().getTime(),
        presRegione: null,
        matricola: null,
        presCognome: null,
        presNome: null,
        presCodiceFiscale: null,
        codiceSpecializzazioneMedico: null,
        descrizioneDiagnosi: null,
        statoAttuale: null,
        nonEsente: false,
        esenteReddito: false,
        codiceEsenzione: null,
        priorita: null,
        cfMedico: null,
        prestazioni: [],

      });
      me.hide();
    },
    onCreaImpegnativaInternal() {
      this.openShowModalLoading();
      let validation = this.validation();
      if (!validation.esito) {
        toast.validation(validation)
        this.closeShowModalLoading();
        return;
      }
      axios
        .post(process.env.VUE_APP_PATH_API + this.pathResource, this.localData)
        .then((response) => {
          this.closeShowModalLoading();
          response;
          toast.success("Salvataggio avvenuto con successo")
          this.hide();
        })
        .catch((error) => {
          this.closeShowModalLoading();
          toast.error(error.response.data.messaggio);
        });

    },
    validation() {
      let esito = true;
      let msg = "";
      if (this.localData.quantitaErogabile <= 0) {
        msg += "Seleziona il ciclo della ricetta ! #";
        esito = false;
      }
      if (this.localData.prestazioni.length == 0) {
        msg += "Seleziona almeno una prestazione #";
        esito = false;
      }


      return { esito: esito, msg: msg };
    },
    onAggiungiImpegnativa() {
      let me = this;

      me.$emit("onAggiungiImpegnativa", me.localData, this.jsonDataIntegrazione);
      me.jsonDataIntegrazione = null;
      me.hide();
      me.localData = {
        tipologiaRicetta: null,
        dataPrescrizione: new Date().getTime(),
        dataInizioErogazione: new Date().getTime(),
        dataFineErogazione: new Date().getTime(),
        presRegione: null,
        matricola: null,
        presCognome: null,
        statoAttuale: null,
        quantitaErogabile: 0,
        presNome: null,
        presCodiceFiscale: null,
        codiceSpecializzazioneMedico: null,
        descrizioneDiagnosi: null,
        nonEsente: false,
        esenteReddito: false,
        codiceEsenzione: null,
        classePriorita: null,
        prestazioni: [],
      };
    },
    loadRegioni() {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + "/regioni";
      axios.get(link).then((response) => {
        response.data.data.forEach((regione) => {
          me.regioniOptions.push(regione);
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
